import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GenericMessageDialogComponent } from '@app/dialogs/generic-message-dialog/generic-message-dialog.component';
import HwUtils from '@app/helpers/HwUtils';
import LocalStorage from '@app/helpers/LocalStorage';
import SessionStorage from '@app/helpers/SessionStorage';
import { GenericMessage } from '@app/interfaces/generic-message';
import { AuthService } from '@app/services/auth.service';
import { LocalStorageService } from '@app/services/localstorage.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-tablet-setup-component',
  templateUrl: './tablet-setup.component.html',
  styleUrls: ['./tablet-setup.component.scss']
})
export class TabletSetupComponent {
  /**
   *
   */
  editorForm: FormGroup
  constructor(

    private localStorageService: LocalStorageService,
    private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private dialog: MatDialog,
    private translate : TranslateService
  ) {
    const dev = localStorageService.getDeviceId() ? localStorageService.getDeviceId() : ''
    const hot = localStorageService.getHotel3pId() ? localStorageService.getHotel3pId() : ''
    const grp = localStorageService.getGroup3Pid() ? localStorageService.getGroup3Pid() : '00000000-0000-0000-0000-000000000000'
    const opm = localStorageService.getOperationMode() ?  localStorageService.getOperationMode() : 'VIP' 
    const tabletMode = LocalStorage.IsTabletMode;

    this.editorForm = fb.group({
      Device3Pid: new FormControl(dev, Validators.required),
      Hotel3Pid: new FormControl(hot, Validators.required),
      Group3Pid: new FormControl(grp, Validators.required),
      TabletMode: new FormControl(tabletMode),
      OperationMode: new FormControl( opm)
    })

  }



  async submit() {
    this.localStorageService.setDeviceId(this.editorForm.controls["Device3Pid"].value);
    this.localStorageService.setHotel3pId(this.editorForm.controls["Hotel3Pid"].value);
    this.localStorageService.setGroup3Pid(this.editorForm.controls["Group3Pid"].value)
    this.localStorageService.setOperationMode(this.editorForm.controls["OperationMode"].value)
    LocalStorage.IsTabletMode = this.editorForm.controls["TabletMode"].value;
    await this.createToken()
    this.router.navigateByUrl("/startcheckin")
  }
  cancel() {
    this.router.navigateByUrl("/startcheckin")
  }

  async createToken() {
    let dp = HwUtils.GenerateDailyPassword()
    try {
      let token = await   firstValueFrom(this.authService.CreateTabletToken(dp, LocalStorage.Hotel3Pid)) 
      LocalStorage.TabletToken = token.toString();

    } catch ( error) {
        let messageData: GenericMessage = { messageText: this.translate.instant('common.network_error'), messageType: 'ERROR', showIcon: true }
        const dialogRef = this.dialog.open(GenericMessageDialogComponent, {
          disableClose: true,
          hasBackdrop: true,
          minWidth: "auto",
          data: messageData
        })

    }

  }


 

}
